<template>
<div>
<v-dialog min-width="500" max-width="500" v-model="settings.visible" :fullscreen="$vuetify.breakpoint.smAndDown" transition="v-fade-transition" scrollable :hide-overlay="false" persistent>
 
 <div :style="{height: dialogHeight}" class="dialog-container">

    <div class="dialog-header">
        <v-toolbar dark flat dense class="primary">
            <v-toolbar-title class="white--text">Contact</v-toolbar-title>
            <v-spacer/>
            <v-menu offset-y left>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on">more_vert</v-icon>
                </template>
                <v-list>
                    <v-list-item @click="resetContactImage()">
                        <v-list-item-title>Reset Image</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>   
        </v-toolbar>  
    </div>

    <div class="dialog-body pa-4" >
        <ContactDetails ref="contactDetails" :contact="contact" />    
    </div>

    <div class="dialog-footer">
        <DeleteButton v-if="contact.meta.key" @delete="deleteContact" style="float:left"></DeleteButton>
        <v-btn text @click.native="saveContact">Save</v-btn>
        <v-btn text @click.native="cancelEdit">Cancel</v-btn>
    </div>
    
</div>
     
</v-dialog>
</div>
</template>

<script>
// 
import ContactHelpers from '../helpers/ContactHelpers'
import Utilities from '../helpers/Utilities'
import DeleteButton from '../ui-elements/DeleteButton'
import ContactDetails from '../ui-elements/ContactDetails'
import DataHelpers from '../helpers/DataHelpers';
import NiceData from '../data/NiceData'
import { debug } from 'util'


export default {
    components: {
        'DeleteButton': DeleteButton,
        'ContactDetails': ContactDetails
    }, 
    props: {
        contactItem: Object,
        settings: Object
    },
    data() {
        return {
            officeDisabled:false,
            contact: {
                meta: {},
                firstName: null,
                preferredName: null,
                middleName: null,
                lastName: null,
                address: null,
                mobile: null,
                email: null,
                dob: null,
                image: null,
                owner: null,
                notes: null,
                groups: null,
            }  
        }
    },

    computed: {

        dialogHeight() {
            if(this.$vuetify.breakpoint.smAndDown)
                return '100%'
            else
                return '500px'
        },          
    },

    watch: {
        'settings.visible' (newVal) {
            if(newVal) {
                this.initialiseDialog()
            } else {
                this.resetForm()
            }
        }
    },

    methods: {

        initialiseDialog() {
            Utilities.copyProperties(this.contactItem, this.contact)

            setTimeout( () => {
                this.$refs.contactDetails.setInitialFocus()
                if(this.contact.meta && this.contact.meta.key)
                    this.officeDisabled = true
            }, 300)
        },

        fullName(contact) {
            return ContactHelpers.fullName(contact)
        },
        saveContact () {
            console.log('ContactEditor > saveContact')
            if(!this.$refs.contactDetails.validate()) {
                console.log('cant continue...invalid')
                return
            }

            if(!this.contact.meta)
                debugger

            if(this.contact.user)
                this.saveProfilePic(this.contact)
            
            ContactHelpers.saveContact(this.contact)
            this.settings.visible = false
            this.$emit('saved', this.contact)
        },

        saveProfilePic(contact) {
            let image = contact.image
            let uid = contact.meta.key
            let ref = DataHelpers.getRootRef().child('users').child(uid).child('image')
            
            ref.set(image)
        },

        cancelEdit () {
            console.log('ContactEditor > cancelEdit')
            this.settings.visible = false
        },

        resetForm() {
                //this should be delayed, but the timeout causes an error

            setTimeout( () => {
                console.log('ContactEditor > resetForm')
                this.settings.tab = 'details-tab'
                this.contact.owner = null
                this.contact.firstName = null
                this.contact.preferredName = null
                this.contact.address = null
                this.contact.middleName = null
                this.contact.lastName = null
                this.contact.business = null
                this.contact.phone = null
                this.contact.fax = null
                this.contact.email = null
                this.contact.mobile = null
                this.contact.partner = null
                this.contact.notes = null
                this.contact.image = null
                this.contact.dob = null
                this.contact.groups = {}
                this.contact.meta = {}
                this.$refs.contactDetails.collapse()

            },300)
        },

        deleteContact () {
            console.log('ContactEditor > deleteContact')
            ContactHelpers.deleteContact(this.contact)
            this.settings.visible = false
            this.$emit('deleted', this.contact)
        },
        
        resetContactImage() {
            this.contact.image = ContactHelpers.getGenderImage(this.contact.gender)
        }
        
    },
}
</script>

<style>


</style>    


// WEBPACK FOOTER //
// ContactEditor.vue?1af7f520